import { render, staticRenderFns } from "./indexTitle.vue?vue&type=template&id=55b87cdc&scoped=true"
import script from "./indexTitle.vue?vue&type=script&lang=js"
export * from "./indexTitle.vue?vue&type=script&lang=js"
import style1 from "./indexTitle.vue?vue&type=style&index=1&id=55b87cdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b87cdc",
  null
  
)

export default component.exports